import React from 'react';


import '../../../../animal-card.css';
import '../../../../tabs/animal-card-tab.css';
import '../../entries-tabs.css';
import TabNavButtons from '../../tab-nav-buttons';


const OwnershipTab = props => {

    return (
        <div className="tab">
            <form>
                <h3>OwnershipTap</h3>

                <TabNavButtons parentProps={props} />
            </form>
        </div>
    )
};

export default OwnershipTab;